import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/icons/active.svg'
import _imports_1 from '@/assets/icons/idle.svg'
import _imports_2 from '@/assets/icons/inactive.svg'
import _imports_3 from '@/assets/icons/pagefirstenabled.svg'
import _imports_4 from '@/assets/icons/pagefirstdisabled.svg'
import _imports_5 from '@/assets/icons/pagelastenabled.svg'
import _imports_6 from '@/assets/icons/pagelastdisabled.svg'


const _hoisted_1 = {
  key: 0,
  src: _imports_0,
  alt: "activeiconimg",
  title: "activeiconimg"
}
const _hoisted_2 = {
  key: 1,
  src: _imports_1,
  alt: "idleiconimg",
  title: "idleiconimg"
}
const _hoisted_3 = {
  key: 2,
  src: _imports_2,
  alt: "inactiveiconimg",
  title: "inactiveiconimg"
}
const _hoisted_4 = { style: {"margin-left":"5px"} }
const _hoisted_5 = {
  key: 0,
  class: "pagingdiv"
}
const _hoisted_6 = { class: "pagelabel" }
const _hoisted_7 = {
  key: 0,
  src: _imports_3,
  style: {"width":"20px"},
  alt: "pagefirstenabledimg",
  title: "pagefirstenabledimg"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_4,
  style: {"width":"20px"},
  alt: "pagefirstdisabledimg",
  title: "pagefirstdisabledimg"
}
const _hoisted_9 = {
  key: 0,
  src: _imports_5,
  style: {"width":"20px"},
  alt: "pagelastenabledimg",
  title: "pagelastenabledimg"
}
const _hoisted_10 = {
  key: 1,
  src: _imports_6,
  style: {"width":"20px"},
  alt: "pagelastdisabledimg",
  title: "pagelastdisabledimg"
}
const _hoisted_11 = { class: "text-div" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "All user data and credential-based licenses will be permanently removed.", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "This action may not be undone.", -1)
const _hoisted_15 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserOptions = _resolveComponent("UserOptions")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_UserOptions, {
      sortField: _ctx.sorttingField,
      sortOrder: _ctx.sortOrder
    }, null, 8, ["sortField", "sortOrder"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "companyusersTableRef",
      id: "companyuserstable",
      data: _ctx.companyUsersList,
      style: {"width":"100%"},
      "max-height": "600px",
      "scrollbar-always-on": "",
      "header-cell-style": _ctx.headerstyle,
      "header-row-style": _ctx.headerrow,
      "row-style": _ctx.rowdatastyle,
      onSelectionChange: _ctx.handleSelectionChange,
      onSortChange: _ctx.handleSorting,
      "default-sort": { prop: 'name', order: 'aescending' },
      "empty-text": "No users available"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }),
        _createVNode(_component_el_table_column, {
          label: "User Name",
          prop: "name",
          sortable: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "Email",
          prop: "email",
          sortable: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "Assigned Products",
          sortable: ""
        }, {
          default: _withCtx((props) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.products, (prod, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(prod.productName) + " " + _toDisplayString(prod.majorVersionNumber) + "." + _toDisplayString(prod.minorVersionNumber), 1))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Assigned Add-ons",
          align: "center",
          prop: "addOns"
        }, {
          default: _withCtx((props) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.addOns, (addon, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(addon.productName) + " " + _toDisplayString(addon.majorVersionNumber) + "." + _toDisplayString(addon.minorVersionNumber), 1))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Status",
          width: "150",
          prop: "userStatus",
          sortable: ""
        }, {
          default: _withCtx((user) => [
            (user.row.userStatus === 'Active')
              ? (_openBlock(), _createElementBlock("img", _hoisted_1))
              : _createCommentVNode("", true),
            (user.row.userStatus === 'Idle')
              ? (_openBlock(), _createElementBlock("img", _hoisted_2))
              : _createCommentVNode("", true),
            (user.row.userStatus === 'Deleted')
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("label", _hoisted_4, _toDisplayString(user.row.userStatus), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style", "header-row-style", "row-style", "onSelectionChange", "onSortChange"])), [
      [_directive_loading, _ctx.loading]
    ]),
    (_ctx.totalPages > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, [
            _createElementVNode("strong", null, "Page " + _toDisplayString(_ctx.currentPage) + " / " + _toDisplayString(_ctx.totalPages), 1)
          ]),
          _createVNode(_component_el_button, {
            plain: "",
            class: "paginationbtn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentPage = 1)),
            id: "firstpage",
            disabled: _ctx.currentPage === 1
          }, {
            default: _withCtx(() => [
              (_ctx.currentPage !== 1)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : _createCommentVNode("", true),
              (_ctx.currentPage === 1)
                ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_pagination, {
            layout: "prev, next",
            total: _ctx.totalRowsCount,
            "page-size": 10,
            "current-page": _ctx.currentPage,
            "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event))
          }, null, 8, ["total", "current-page"]),
          _createVNode(_component_el_button, {
            plain: "",
            class: "paginationbtn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentPage = _ctx.totalPages)),
            id: "lastpage",
            disabled: _ctx.currentPage === _ctx.totalPages
          }, {
            default: _withCtx(() => [
              (_ctx.currentPage !== _ctx.totalPages)
                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                : _createCommentVNode("", true),
              (_ctx.currentPage === _ctx.totalPages)
                ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      title: "Delete Users",
      modelValue: _ctx.showDeleteDailogue,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showDeleteDailogue) = $event)),
      width: "35%",
      top: "25vh",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_15, [
          _createVNode(_component_el_button, {
            id: "deleteusercancel",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDeleteDailogue = false)),
            round: "",
            class: "cancelbtn",
            variant: "outline-dark"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _ctx.deleteUser,
            round: "",
            class: "deletebutton",
            id: "deleteuserconfirm"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Confirm")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_divider),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.getSlectedEmails.length), 1),
            _createTextVNode(" Users selected ")
          ]),
          _hoisted_12,
          _hoisted_13,
          _hoisted_14
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}